<div
  class="pointer-events-auto flex min-w-72 max-w-xs items-center gap-3 rounded-xl px-4 py-3 shadow-lg"
  [class]="config().wrapperClasses"
>
  <ng-icon class="shrink-0" [name]="config().icon" [color]="config().color" size="1.25rem" />
  <p class="flex-1 text-body" [style.color]="config().color">{{ message() }}</p>
  @if (showCloseButton()) {
    <button class="shrink-0 cursor-pointer" type="button" (click)="closed.emit()">
      <ng-icon name="featherX" [color]="config().color" size="1rem" />
    </button>
  }
</div>
